export default __webpack_public_path__ + "static/media/more-services-3.f7e12dd8.svg";